export default "__VITE_ASSET__st_9hcg3__"